import request from '@/utils/request'
const platform = localStorage.getItem('platform')

export function getAdTasks(data) {
    return request.get(`/${platform}/bd_ad_tasks`, data)
}

export function deleteAdTasks(ids) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.delete(`/${platform}/bd_ad_tasks/${ids}`)
}

export function storeOrUpdateAdTask(data) {
    const method = data.id ? 'put' : 'post'
    const url = data.id ? `/${platform}/bd_ad_tasks/${data.id}` : `/${platform}/bd_ad_tasks`;
    return request[method](url, data)
}
